module.exports = __webpack_public_path__ + "img/10.3454e56b.jpg";